/**
 * @fileoverview a wrapper for highcharts so we can bridge the existing analytics
 *   experiences with React
 */

import React, { useMemo } from "react";

import { useId } from "@braze/beacon-hooks";

import ErrorBoundary from "@components/ErrorBoundary";

import { HighchartsWrapperContent } from "./HighchartsWrapperContent";
import type { HighchartsWrapperProps } from "./types";
import { getOperatorTimeSeriesData } from "./utils/getOperatorTimeSeriesData";

export const HighchartsWrapper = ({
  className,
  chartConfig,
  allowChartUpdate,
  immutable,
  ErrorBoundaryButtonComponent,
  operatorChartData,
}: HighchartsWrapperProps): React.ReactElement => {
  const operatorId = useId("highcharts-chart");
  // Memoize the expensive legacy extraction when no explicit data is supplied.
  // Explicit data is used directly; either input changing recomputes this value.
  const normalizedData = useMemo(
    () => (operatorChartData === undefined ? getOperatorTimeSeriesData(chartConfig) : operatorChartData),
    [chartConfig, operatorChartData]
  );

  return (
    <ErrorBoundary
      team="frontend_ix"
      featureId="HighChartsWrapper-HighchartsReact"
      ButtonComponent={ErrorBoundaryButtonComponent}
    >
      <HighchartsWrapperContent
        className={className}
        chartConfig={chartConfig}
        allowChartUpdate={allowChartUpdate}
        immutable={immutable}
        operatorChartData={normalizedData}
        operatorId={operatorId}
      />
    </ErrorBoundary>
  );
};
